export default __webpack_public_path__ + "static/media/Neolin_lg.3735df26.png";